import { ToolBase } from "../../agents/base/toolBase";
import { ToolDescription } from "../../agents/base/toolDescription";
import { PromptGetParamsSchema, } from "./promptGet.schema";
export function createPromptGetTool(sections) {
    return new PromptGetTool(sections);
}
class PromptGetTool extends ToolBase {
    constructor(sections) {
        super();
        this.name = "promptGet";
        this.description = new ToolDescription("promptGet", "Get prompt-library sections by ID.", PromptGetParamsSchema);
        this.paramsSchema = PromptGetParamsSchema;
        this.fieldsToCheck = [
            { name: "uiDescription", type: "string", list_status: false, order: 0 },
        ];
        this._sections = sections;
        this._sectionMap = new Map(sections.map(s => [s.id, s]));
        this.systemPromptDescription = this.buildSystemPromptDescription();
    }
    buildSystemPromptDescription() {
        const index = this._sections
            .map(s => `- \`${s.id}\` — "${s.title}" [${s.tags.join(", ")}]`)
            .join("\n");
        return [
            "### promptGet",
            "Retrieve full text for one or more prompt-library section IDs.",
            "",
            "Use after promptSearch, or call directly if you know the ID from the index below.",
            "Keep requests focused (1–3 IDs) to avoid large context injections.",
            "",
            "**Available sections:**",
            index,
        ].join("\n");
    }
    async execute(params) {
        const sections = [];
        const missingIds = [];
        for (const id of params.ids) {
            const section = this._sectionMap.get(id);
            if (!section) {
                missingIds.push(id);
                continue;
            }
            sections.push({
                id: section.id,
                title: section.title,
                tags: section.tags,
                content: section.content,
            });
        }
        return { sections, missingIds };
    }
}
